"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import sectionStyles from "./LooksSection.module.css";

export default function DeferredLooksSection() {
  const [LooksSection, setLooksSection] = useState(null);
  const sectionRef = useRef(null);
  const loadingRef = useRef(null);

  const loadSection = useCallback(() => {
    if (loadingRef.current) return loadingRef.current;
    loadingRef.current = import("./LooksSection").then((mod) => {
      setLooksSection(() => mod.default);
      return mod.default;
    });
    return loadingRef.current;
  }, []);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return;

    if (!("IntersectionObserver" in window)) {
      loadSection();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          loadSection();
        }
      },
      { rootMargin: "600px 0px" }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [loadSection]);

  if (LooksSection) {
    return <LooksSection />;
  }

  return (
    <section className={sectionStyles.section} ref={sectionRef}>
      <div className={sectionStyles.container}>
        <div className={`${sectionStyles.header} ${sectionStyles.visible}`}>
          <h2 className={sectionStyles.title}>Try it out for yourself</h2>
          <p className={sectionStyles.subtitle}>
            Control themes, buttons, timelines, and behavior
            <br className={sectionStyles.mobileBreak} /> so your video player matches the goal of the page.
          </p>
        </div>
        <div
          className={`${sectionStyles.inlineContainer} ${sectionStyles.visible}`}
          style={{ minHeight: "520px" }}
          aria-hidden="true"
        />
      </div>
    </section>
  );
}
